!(function(t) {
	t.fn.slider = function(i) {
		var n = { rollback: !0, duration: 400, width: "26%" },
			e = t.extend(n, i);
		return this.each(function() {
			var i = t(this),
				n = i.find(".js-slider-last-container");
			i.mousemove(function(e) {
				t(n).css({ width: i.width() - (e.pageX - i.offset().left) });
			}),
				e.rollback &&
					i.mouseleave(function() {
						n.animate({ width: e.width }, e.duration);
					});
		});
	};
})(jQuery);
